<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
<!--                    <nav aria-label="breadcrumb">-->
<!--                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">-->
<!--                                                        <li class="breadcrumb-item"><a href="#">Dashboard</a></li>-->
<!--                                                        <li class="breadcrumb-item active" aria-current="page">Sales Monitoring</li>-->
<!--                        </ol>-->
<!--                    </nav>-->
                    <h4 class="mg-b-0 tx-spacing--1">Welcome
                        <span v-if="system.userInfo != null">
                            {{system.userInfo.firstName}}
                        </span></h4>
                </div>
                <div class="d-none d-md-block">
                    <new-account-button></new-account-button>
                    <router-link to="/new-officer" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="plus" class="wd-10 mg-r-5"></i> New Officer</router-link>
                    <button style="background-color: #6d0606; border-color: #6d0606;" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <download-excel
                                class   = "lnr-cloud-download"
                                style="cursor: pointer;"
                                :data   = "ftLogs"
                                worksheet = "My Worksheet"
                                :name    = "$route.name+'.xls'">
                            <span> <i data-feather="file" class="wd-10 mg-r-5"></i> Generate Report</span>
                        </download-excel>
                    </button>
                    <button :disabled="report.reportsLoading" @click="generate()" style="background-color: #237eff; border-color: #237eff;" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <i v-if="!report.reportsLoading" data-feather="file" class="wd-10 mg-r-5"></i>
                        <b-spinner style="font-size: 10px; height: 15px; width: 15px;" v-else/>
                        Get Full Report
                    </button>
                </div>
            </div>

            <!--TODO TOP CARDS-->
            <top-cards></top-cards>
            <!--TODO GROWTH-->
            <div class="row">
                <div class="col-md-12 mg-t-10">
                    <div class="card ht-100p">
                        <div class="card-header d-flex align-items-center justify-content-between">
                            <h6 class="mg-b-0">Transactions <i data-feather="chevrons-right" class="wd-10 mg-r-5"></i></h6>
                            <div class="d-flex tx-18">
                                <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                                <router-link to="/new-officer" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-add"></i></router-link>
                            </div>
                        </div>
                        <base-table
                                :type="'ft'"
                                :items="ftLogs"
                                :fields="fields"
                                :show-title="true"
                                :is-busy="logs.ftLoading"
                                class="mt-2"
                        ></base-table>
                    </div>
                </div>
            </div>


        </div><!-- container -->
    </div>
</template>

<script>
    import TopCards from "../../components/card/TopCards";
    import BaseTable from "../../components/table/BaseTable";
    import NewAccountButton from "../../components/button/NewAccountButton";
    import {mapState} from 'vuex';

    export default {
        name: 'Home',
        components:{
            TopCards,
            BaseTable,
            NewAccountButton,
        },
        data(){
            return{
                fields: [
                    { key: 'serial', label: 'S/N', sortable: true},
                    { key: 'nibssresponsemessage', label: 'Status', sortable: true},
                    // { key: 'reference', label: 'Reference', sortable: true, 'class': 'text-left' },
                    { key: 'debitaccount', label: 'DebitAccount', sortable: true, 'class': 'text-left' },
                    { key: 'creditaccount', label: 'CreditAccount', sortable: true, 'class': 'text-left' },
                    { key: 'amount', label: 'Amount', sortable: true, 'class': 'text-right' },
                    // { key: 'nibssresponsemessage', label: 'Remark', sortable: true, 'class': 'text-left' },
                    // { key: 'requestdatetime', label: 'Request Time', sortable: true, 'class': 'text-left' },
                    { key: 'responsedatetime', label: 'ResponseTime', sortable: true,  sortDirection: 'desc',  'class': 'text-left' },
                    { key: 'actions', label: 'Actions', sortable: true, 'class': 'text-left' }
                    // { key: 'actions', label: 'Actions' }
                ],
                items:[]
            }
        },
        methods:{
            onFiltered (filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.filteredData = filteredItems
                this.currentPage = 1
            },
            generate(){
                this.$store.dispatch("report/readReports", {
                    customerId: this.company.account[0].accCustID,
                    requestType:'ftlogs',
                    dialogs:this.$dialogs
                }, {root: true})
            },
            formatJson(_items){
                let newItem = []
                for (let i = 0; i < _items.length; i++){
                    let newItemObj = {}

                    if (_items[i].reference != null)
                        newItemObj.reference = _items[i].reference;
                    else
                        newItemObj.reference = '-';
                    if (_items[i].transactionstatus != null)
                        newItemObj.transactionstatus = _items[i].transactionstatus;
                    else
                        newItemObj.transactionstatus = '-';

                    newItemObj.amount = _items[i].amount;
                    newItemObj.nibssresponsemessage = _items[i].nibssresponsemessage;

                    if (_items[i].draccountname != null){
                        newItemObj.requestdatetime = _items[i].requestdatetime;
                    }else{
                        newItemObj.requestdatetime = '-'
                    }

                    if (_items[i].draccountname != null){
                        newItemObj.responsedatetime = _items[i].responsedatetime;
                        newItemObj.creditaccount = _items[i].draccountname + ' - ' + _items[i].draccount
                        newItemObj.debitaccount = _items[i].craccountname + ' - ' + _items[i].craccount
                    }else{
                        newItemObj.creditaccount = '-';
                        newItemObj.debitaccount = '-';
                        newItemObj.responsedatetime = '-';
                    }
                    newItem.push(newItemObj)
                }
                return newItem
            },
            async query(){
                this.$store.commit("logs/updateFtLogs",[])
                await this.$store.dispatch("logs/readFtLogs", {
                    customerId: this.company.account[0].accCustID,
                    startDate: this.startDate,
                    endDate: this.endDate
                }, {root: true})
                this.items = this.formatJson(this.logs.ftLogs)
                this.totalRows = this.items.length
                this.filteredData = this.formatJson(this.logs.ftLogs)
            },
            async readFtLogs(){
                // accNumber
                console.log(this.company.account)
                await this.$store.dispatch("logs/readFtLogs", {
                    customerId: this.company.account[0].accCustID,
                    startDate: this.startDate,
                    endDate: this.endDate
                }, {root: true})
                this.items = this.formatJson(this.logs.ftLogs)//.sort(this.sortByProperty('responsedatetime'))
                this.totalRows = this.items.length
                this.filteredData = this.formatJson(this.logs.ftLogs)
            },
        },
        computed:{
            ...mapState([
                'report',
                'officer',
                'company',
                'system',
                'logs'
            ]),

            ftLogs:{
                get(){
                    return this.formatJson(this.logs.ftLogs)
                },
                set(val){
                   this.$store.commit('logs/ftLogs', val)
                }
            },
        },
        mounted() {
            // this.items = this.formatJson(this.logs.ftLogs)//.sort(this.sortByProperty('responsedatetime'))
            // this.filteredData = this.formatJson(this.logs.ftLogs)
            // this.totalRows = this.items.length
            // eslint-disable-next-line no-console
            // console.log(this.items)
            this.readFtLogs()
        }
    }
</script>
